import React, {memo} from 'react'

/* Styles */
import s from './product-card.scss'

const TagLabel = memo(({tagLabels, outOfStock}) => {
  const validateColor = (color) => {
    if(color && color.startsWith('#')) {
      return color
    }else {
      return `#${color}`
    }
  }
  const label = (() => {
    if (outOfStock) {
      return {
        textColor: '#FFF',
        backgroundColor: '#646464',
        text: 'Tükendi'
      }
    }

    if (tagLabels?.length > 0) {
      return tagLabels[0]
    }

    return {}
  })()

  return (
    <div className={s.tagLabel} style={{color: validateColor(label?.textColor), background: validateColor(label?.backgroundColor)}} aria-hidden='true'>
      {label?.text}
    </div>
  )
})

export default TagLabel
